import { Box, BoxProps, Image, ImageProps } from '@chakra-ui/react'
import React from 'react'

export interface GenericImageProps {
  /** Image source URL. */
  src: string
  /** Native image element attributes (e.g. `alt`, `width`, `height`). */
  imageProps?: ImageProps
  boxProps?: BoxProps
}

/**
 * GenericImage – A simple image for use as supporting content inside GenericSection.
 */
export const GenericImage: React.FC<GenericImageProps> = ({ src, imageProps, boxProps }) => {
  return (
    <Box
      bgColor={'colorPalette.panel'}
      border={'1px solid'}
      borderColor={'colorPalette.border/50'}
      borderRadius={'2xl'}
      lineHeight={0}
      overflow={'hidden'}
      padding={4}
      width={'full'}
      css={{
        '& img': {
          display: 'block',
          width: '100%',
          height: 'auto',
        },
      }}
      {...boxProps}
    >
      <Image
        alt={imageProps?.alt ?? ''}
        borderRadius={'2xl'}
        overflow={'hidden'}
        src={src}
        width={'full'}
        {...imageProps}
      />
    </Box>
  )
}

export default GenericImage
